import React, { Component } from 'react'
import { connect } from 'react-redux'
import RightArrowSvg from './svg/RightArrowSvg';
import BottomArrowSvg from './svg/BottomArrowSvg';
import { getEurocoldSubCatagory } from '../actions/MainAction';

export class EuroColdCatagoryList extends Component {
    state = {
        visible: false,
    }

    componentDidMount() {
        this.props.getEurocoldSubCatagory();
    }

    handleSubClick = (subId) => {
        if (this.props.onSubCategoryClick) {
            this.props.onSubCategoryClick(subId);
        }
    }

    render() {
        const { visible } = this.state;
        const { eurocoldSubCatagoryData, catagory, id } = this.props;



        return (
            <div>
                <div className='flex flex-col bg-[#fff] max-[1024px]:bg-[var(--body)]  w-full '>
                    <div onClick={() => this.setState({ visible: !visible })} className='flex items-center gap-[10px] w-full justify-between cursor-pointer'>
                        <p className='font-[500] text-[20px] leading-[32px] text-[#272727]'>
                            {catagory}
                        </p>
                        <div className='cursor-pointer mt-[6px] w-[20px]'>
                            {!visible ? <RightArrowSvg /> : <BottomArrowSvg />}
                        </div>
                    </div>

                    {visible && (
                        <div>
                            {eurocoldSubCatagoryData?.filter(sub => sub.euro_cold_catagories === id)
                                ?.map((sub, index) => (
                                    <button
                                        key={index}
                                        onClick={() => this.handleSubClick(sub?.id)}
                                        className='font-[400] text-start text-[18px] border-b-[1px] leading-[32px] text-[#272727] block'
                                    >
                                        {sub?.title}
                                    </button>
                                ))}
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

const mapStateProps = (state) => ({
    eurocoldSubCatagoryData: state.Data.eurocoldSubCatagoryData
})

const mapDispatchToProps = { getEurocoldSubCatagory }

export default connect(mapStateProps, mapDispatchToProps)(EuroColdCatagoryList)
